import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
const AboutUs = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  return (
    <>
      {/* =============== About Area Two End ===============*/}
      <div className="about-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-delay="100"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner">
                <img
                  className="main-img"
                  src="assets/img/hna-meak/image landing page/Design sans titre.png"
                  alt="img"
                  style={{ width: "550px" }}
                />
              </div>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-delay="100"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0">
                <div
                  className={`section-title mb-0 ${isArabic ? "text-end" : ""}`}
                >
                  <h2 className="title">{t("about.title")}</h2>
                </div>

                <p
                  className="content mb-4"
                  style={{ fontSize: "18px", lineHeight: "1.8" }}
                >
                  {t("about.text.part1")}  
                  <strong style={{ color: "#f26522" }}>
                    {t("about.text.highlight1")}
                  </strong>{" "}
                  {t("about.text.part2")}{" "}
                  <strong style={{ color: "#f26522" }}>
                    {t("about.text.highlight2")}
                  </strong>
                </p>

                <div className="d-flex gap-3">
                  <ScrollLink
                    to="contact-section"
                    className="btn btn-base orange-shadow-btn"
                  >
                    {t("about.buttons.rdv")}
                  </ScrollLink>
                  <Link
                    className="btn btn-light"
                    style={{ boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.329)" }}
                    to="/centre-appel"
                  >
                    {t("about.buttons.callCenter")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =============== About Area Two End ===============*/}
    </>
  );
};

export default AboutUs;
